import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext, useEffect } from 'react';
import { SdkRuntimeContext } from '../../provider/SdkRuntimeContext.js';
import { ScreenVisibilityContext } from '../context/ScreenVisibilityContext.js';
const listeners = new WeakMap();
export function onConvictionProjectionInterestChanged(qc, listener) {
  let group = listeners.get(qc);
  if (group === undefined) {
    group = new Set();
    listeners.set(qc, group);
  }
  group.add(listener);
  return () => {
    group.delete(listener);
  };
}
const interests = new WeakMap();
export function hasConvictionProjectionInterest(qc, id) {
  return (interests.get(qc)?.get(id) ?? 0) > 0;
}
export function acquireConvictionProjectionInterest(qc, id) {
  let counts = interests.get(qc);
  if (counts === undefined) {
    counts = new Map();
    interests.set(qc, counts);
  }
  counts.set(id, (counts.get(id) ?? 0) + 1);
  for (const listener of listeners.get(qc) ?? []) listener(id);
  return () => {
    const remaining = (counts.get(id) ?? 1) - 1;
    if (remaining === 0) counts.delete(id);else counts.set(id, remaining);
    for (const listener of listeners.get(qc) ?? []) listener(id);
  };
}
export function useConvictionProjectionInterest(qc, id) {
  const runtime = useContext(SdkRuntimeContext);
  const {
    visible
  } = useContext(ScreenVisibilityContext);
  const useFocusEffect = runtime?.adapter.screenFocus.useFocusEffect ?? useMountedEffect;
  useFocusEffect(useCallback(() => {
    if (id === undefined || id.length === 0 || !visible) return;
    return acquireConvictionProjectionInterest(qc, id);
  }, [qc, id, visible]));
}
function useMountedEffect(effect) {
  const $ = _c(2);
  let t0;
  if ($[0] !== effect) {
    t0 = [effect];
    $[0] = effect;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(effect, t0);
}